import i from "../../index";

export default i;
